import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import CustomModal from '../../CustomModal';
import Image from '../../Image';
import userLock from '../../../assets/user-lock.png';
import { closeModal, openModal } from '../../../redux/slices/profileSlice';
import useLocales from '../../../hooks/useLocales';

const HintDialogPasswordDialog = ({ handleClose, handleOpen }) => {
  const handleOkay = () => {
    dispatch(openModal({ view: 'reset-password' }));
  };
  const { translate } = useLocales();
  const dispatch = useDispatch();

  return (
    <CustomModal
      maxWidth={'xs'}
      hasClose={true}
      open={handleOpen}
      onClose={handleClose}
      title="Reset Password"
      actions={
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            width: '100%',
          }}
        >
          <Button
            variant="contained"
            onClick={handleOkay}
            sx={{
              background: (theme) => theme.palette.gradients.buttonPrimary,
              textTransform: 'none',
              borderRadius: '25px',
              width: '279px',
              px: 4,
              boxShadow: 'none',
            }}
          >
            {translate('okay')}
          </Button>
        </Box>
      }
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          py: 2,
          px: {
            xs: 4,
          },
        }}
      >
        <Box>
          <Image src={userLock} style={{ width: 120, height: 120 }} alt="logout" />
        </Box>

        <Typography variant="h6" fontWeight={600}>
          {translate('hint')}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {translate('phone_number_not_associated')}
        </Typography>
      </Box>
    </CustomModal>
  );
};

export default HintDialogPasswordDialog;
